import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { userAuth } from "../../services/userApi";

// Only reachable with a user session; otherwise back to the login screen.
export const UserPrivateRoute = () =>
  userAuth.isLoggedIn() ? <Outlet /> : <Navigate to="/user/login" replace />;

// Login / signup / OTP screens — skip them when already signed in.
export const UserGuestRoute = () =>
  userAuth.isLoggedIn() ? <Navigate to="/user/dashboard" replace /> : <Outlet />;

export const UserIndexRedirect = () => (
  <Navigate to={userAuth.isLoggedIn() ? "/user/dashboard" : "/user/login"} replace />
);
